import { Typography } from '@mui/material';
import { Modal, ModalFooter } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { ModalComponentProps } from '@kc-console/context';

export type ModalClosingConfirmProps = { description: string; title: string } & ModalComponentProps;

const ModalClosingConfirm = (props: ModalClosingConfirmProps) => {
  const { t } = useTranslation();
  const { title, description, onClose, onSubmit, TransitionProps, open = false } = props;

  return (
    <Modal
      open={open}
      onClose={() => onClose({})}
      closeAfterTransition
      size="sm"
      TransitionProps={TransitionProps}
      slotProps={{
        header: {
          title,
        },
        body: {
          children: <Typography>{description}</Typography>,
        },
        footer: {
          labelMap: {
            cancel: t('layout:modal.closing_confirm.stay'),
            confirm: t('layout:modal.closing_confirm.exit'),
          },
          buttons: [
            <ModalFooter.Button
              key="modal-closing-footer-button-stay"
              eventType="cancel"
              onClick={() => onClose({})}
            />,
            <ModalFooter.Button
              key="modal-closing-footer-button-exit"
              eventType="confirm"
              onClick={onSubmit}
            />,
          ],
        },
      }}
    />
  );
};

export default ModalClosingConfirm;
